import { apiCall } from "./service";
import { BASE_URL } from "./URL";

export const api = {
  askQuestion(question) {
    return apiCall.post({ url: `${BASE_URL}agent/ask`, params: { question } });
  },
  transcribeAudio(blob, { timeoutMs = 6000 } = {}) {
    const formData = new FormData();
    formData.append("audio", blob, "recording.webm");
    return apiCall.filePost({ url: `${BASE_URL}agent/transcribe`, params: formData, timeoutMs });
  },
};
export default api;
